import { RefObject } from "react"
import { Message } from "./types"
import { ChatMessage } from "./ChatMessage"
import { useAgentProfile } from "@/hooks/useAgentProfile"

interface ChatMessagesProps {
  messages: Message[]
  messagesEndRef: RefObject<HTMLDivElement | null>
  sessionId: string
  onFeedbackSubmit: (
    messageContent: string,
    feedbackType: "positive" | "negative",
    comment: string
  ) => Promise<void>
  // 選択肢カードのタップを発言として送信（B2）。
  onSendChoice?: (text: string) => void
}

export function ChatMessages({
  messages,
  messagesEndRef,
  sessionId,
  onFeedbackSubmit,
  onSendChoice,
}: ChatMessagesProps) {
  const agentFace = useAgentProfile()
  return (
    <div
      className={`h-full p-4 space-y-4 w-full ${
        messages.length > 0 ? "overflow-y-auto" : "overflow-hidden"
      }`}
    >
      {messages.length === 0 ? (
        <div className="flex items-center justify-center h-full text-gray-400">
          新しい会話を始めましょう
        </div>
      ) : (
        messages.map((message, index) => (
          <ChatMessage
            key={index}
            message={message}
            sessionId={sessionId}
            agentFace={agentFace}
            // 選択肢カードは「会話の最後のメッセージ」にある間だけ活性にする。
            // 回答（後続メッセージ）が付いた時点で onSendChoice を渡さない＝回答済み表示。
            // カード側の done はコンポーネント状態なので、再描画・履歴リロードで
            // リセットされて再送信できてしまう穴があった（2026-07-05 実走で発覚）。
            onSendChoice={index === messages.length - 1 ? onSendChoice : undefined}
            onFeedbackSubmit={async (feedbackType, comment) => {
              await onFeedbackSubmit(message.content, feedbackType, comment)
            }}
          />
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  )
}
